import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { TipoLancamento } from '@models/tipo-lancamento';
import { AlterarTipoLancamentosInput } from '@models/alterar-tipo-lancamentos-input';

@Injectable({
  providedIn: 'root'
})
export class TransferirLancamentoService extends ApiService {

  constructor(public override http: HttpClient) {
    super(http);
  }

  public getTiposLancamento(): Observable<TipoLancamento[]> {
    return this.get<TipoLancamento[]>('/tipos-lancamento');
  }

  public alterarTipo(lancamentoIds: number[], tipoLancamentoId: number, conciliacaoId?: number): Observable<void> {
    const input: AlterarTipoLancamentosInput = { lancamentoIds, tipoLancamentoId, conciliacaoId };
    return this.patch<void>('/lancamento-caixa/alterar-tipo', null, input);
  }
}
